import React, { useEffect, useState } from 'react';
import { FlatList, View } from "react-native"
import { connect } from "react-redux"
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { PostReactionProps, PostReactionStatsProps } from '../../../store/types/soc_svc';

type PostReactionBarProps = {
    post_reaction_stats: PostReactionStatsProps[],
    my_post_reactions: PostReactionProps[],
    featured?:boolean,
    onReactionSelect: (reaction:string) => void
}

const available_reactions = [
    { reaction: 'like', label: '❤️' },
    { reaction: 'celebrate', label: '🎉' },
    { reaction: 'fire', label: '🔥' },
    { reaction: 'clap', label: '👏' },
    { reaction: 'trophy', label: '🏆' },
    { reaction: 'strong', label: '💪' },
    { reaction: 'money', label: '💰' },
    { reaction: 'eyes', label: '👀' },

]

const PostReactionBar = ({ post_reaction_stats, my_post_reactions, featured, onReactionSelect }:PostReactionBarProps) => {
    const [ more_selected, setMoreSelected ] = useState(false);
    const handleReaction = async(reaction:string) => {
        if(!onReactionSelect){ return }
        onReactionSelect(reaction)
        setMoreSelected(false)
    }

    const renderAvailableReactions = (data: {item:any, index:number}) => {
        const reacted = post_reaction_stats.length > 0 && !more_selected
        const reaction_stat = post_reaction_stats.find(p => p.reaction === data.item.reaction)
        const my_reaction = my_post_reactions.find(pr => pr.reaction === data.item.reaction)
        const selected = my_reaction?.status === 'visible' ? true : false
        return (
            <TouchableOpacity style={ 
                reacted ? 
                { ...styles.raisedStyle, marginBottom:5, marginLeft:data.index===0?0:-5, paddingRight:10, paddingLeft:5, flexDirection:'row', alignItems:'center', padding:2, borderRadius:100, backgroundColor:selected?Colors.highlights.highlight200:Colors.shades.white }
                :
                {}} onPress={() => handleReaction(data.item.reaction)}>
                
                <Text style={{fontSize:12, padding:6}}>{data.item.label}</Text>
                {reaction_stat && !more_selected && post_reaction_stats.length < 5 ?
                <Text size={12} color={selected ? Colors.shades.white : Colors.brand.midnight} weight='regular' style={{ padding:3 }}>{reaction_stat.reaction_count}</Text>
                :<></>}
            </TouchableOpacity>
        )
    }

    let visible_reactions = available_reactions
    if(post_reaction_stats.length > 0 && !more_selected){
        visible_reactions = visible_reactions.filter(r => post_reaction_stats.find(pr => pr.reaction === r.reaction))
    }
    return (
        <View style={{ flexDirection:'row', alignItems:'flex-start' }}>
            <View style={post_reaction_stats.length > 0 && !more_selected ? styles.reactionBarStyle : styles.raisedReactionBarStyle}>
                <FlatList listKey='reactions' data={visible_reactions} renderItem={renderAvailableReactions} keyExtractor={(item) => item.reaction} horizontal/>
                {post_reaction_stats.length > 0 && !more_selected ?
                   <TouchableOpacity style={{ ...styles.raisedStyle, marginBottom:5, marginLeft:-4, paddingRight:10, paddingLeft:10, flexDirection:'row', alignItems:'center', padding:2, borderRadius:100, backgroundColor:Colors.shades.white }} onPress={() => setMoreSelected(true)}>
                       <Text size={12} color={Colors.brand.midnight} weight='regular' textAlign='center'>more</Text>
                   </TouchableOpacity> 
                :<></>}
            </View>
        </View>
    )
}

const styles = {
    raisedReactionBarStyle : { paddingTop:9, paddingBottom:9, paddingLeft:16, paddingRight:16, borderRadius: 18, backgroundColor: Colors.shades.white, shadowColor: "rgba(0, 41, 120, 0.12)", shadowOffset: { width: 0, height: 2 }, shadowRadius: 4, shadowOpacity: 1},
    raisedStyle: { shadowColor: "rgba(0, 41, 120, 0.12)", shadowOffset: { width: 0, height: 2 }, shadowRadius: 4, shadowOpacity: 1 },
    reactionBarStyle : { flexDirection:'row', paddingTop:9, paddingBottom:9, paddingRight:16 }

}



export default PostReactionBar